import React from 'react';
import Konva from 'konva';
import { Layer } from 'react-konva';

interface Props {
  children?: React.ReactNode;
  isDrawing?: boolean;
}

const BlocksLayer = ({ ref, children, isDrawing }: Props & { ref?: React.RefObject<Konva.Layer | null> }) => {
  return <Layer ref={ref}>{children}</Layer>;
};

export default BlocksLayer;
